/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstituteAddress } from './InstituteAddress';
import {
    InstituteAddressFromJSON,
    InstituteAddressFromJSONTyped,
    InstituteAddressToJSON,
    InstituteAddressToJSONTyped,
} from './InstituteAddress';

/**
 * 
 * @export
 * @interface InstituteResponse
 */
export interface InstituteResponse {
    /**
     * the unique identifier of the institute
     * @type {string}
     * @memberof InstituteResponse
     */
    id?: string;
    /**
     * the name of the institute
     * @type {string}
     * @memberof InstituteResponse
     */
    name?: string;
    /**
     * the short name of the institute
     * @type {string}
     * @memberof InstituteResponse
     */
    shortName?: string;
    /**
     * the external id of the institute
     * @type {string}
     * @memberof InstituteResponse
     */
    externalId?: string;
    /**
     * the role of the institute
     * @type {string}
     * @memberof InstituteResponse
     */
    instituteRole?: string;
    /**
     * the active status of the institute
     * @type {boolean}
     * @memberof InstituteResponse
     */
    active?: boolean;
    /**
     * tell if the PID is active for that institute
     * @type {boolean}
     * @memberof InstituteResponse
     */
    pidactive?: boolean;
    /**
     * tell if the fast patient creation feature is active for that institute
     * @type {boolean}
     * @memberof InstituteResponse
     */
    fastPatientCreationActive?: boolean;
    /**
     * tell if the ophthalmo dashboard is active for that institute
     * @type {boolean}
     * @memberof InstituteResponse
     */
    ophthalmoDashboardActive?: boolean;
    /**
     * 
     * @type {InstituteAddress}
     * @memberof InstituteResponse
     */
    instituteAddress?: InstituteAddress;
}

/**
 * Check if a given object implements the InstituteResponse interface.
 */
export function instanceOfInstituteResponse(value: object): value is InstituteResponse {
    return true;
}

export function InstituteResponseFromJSON(json: any): InstituteResponse {
    return InstituteResponseFromJSONTyped(json, false);
}

export function InstituteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'instituteRole': json['instituteRole'] == null ? undefined : json['instituteRole'],
        'active': json['active'] == null ? undefined : json['active'],
        'pidactive': json['pidactive'] == null ? undefined : json['pidactive'],
        'fastPatientCreationActive': json['fastPatientCreationActive'] == null ? undefined : json['fastPatientCreationActive'],
        'ophthalmoDashboardActive': json['ophthalmoDashboardActive'] == null ? undefined : json['ophthalmoDashboardActive'],
        'instituteAddress': json['instituteAddress'] == null ? undefined : InstituteAddressFromJSON(json['instituteAddress']),
    };
}

export function InstituteResponseToJSON(json: any): InstituteResponse {
    return InstituteResponseToJSONTyped(json, false);
}

export function InstituteResponseToJSONTyped(value?: InstituteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortName': value['shortName'],
        'externalId': value['externalId'],
        'instituteRole': value['instituteRole'],
        'active': value['active'],
        'pidactive': value['pidactive'],
        'fastPatientCreationActive': value['fastPatientCreationActive'],
        'ophthalmoDashboardActive': value['ophthalmoDashboardActive'],
        'instituteAddress': InstituteAddressToJSON(value['instituteAddress']),
    };
}

